import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsService {
  // Local url to read the variable as environment
  localUrl: any;
  isHTTPS: string = 'False';

  constructor(private http: HttpClient) { }

  // Load urls from the local json file before app bootstrap
  loadConfigService(): Promise<any> {
    this.initializeHttps();

    const storedConfig = localStorage.getItem('localUrl');
    if (storedConfig) {
      try {
        this.localUrl = JSON.parse(storedConfig);
        if (this.hasValidServiceUrl(this.localUrl)) {
          this.initializeCompanyCode();
          return Promise.resolve(this.localUrl);
        }
        localStorage.removeItem('localUrl');
        this.localUrl = null;
      } catch {
        localStorage.removeItem('localUrl');
        this.localUrl = null;
      }
    }

    return this.http.get('assets/config/config.json').toPromise()
      .then((response) => {
        this.localUrl = response;
        localStorage.setItem('localUrl', JSON.stringify(this.localUrl));
        this.initializeCompanyCode();
        return this.localUrl;
      });
  }

  getAppConfig(): any {
    return this.getConfig();
  }

  private getConfig(): any {
    if (this.localUrl && this.hasValidServiceUrl(this.localUrl)) {
      return this.localUrl;
    }

    const storedConfig = localStorage.getItem('localUrl');
    if (storedConfig) {
      try {
        const parsedConfig = JSON.parse(storedConfig);
        if (this.hasValidServiceUrl(parsedConfig)) {
          this.localUrl = parsedConfig;
          return this.localUrl;
        }
        localStorage.removeItem('localUrl');
      } catch {
        localStorage.removeItem('localUrl');
      }
    }

    return null;
  }

  private hasValidServiceUrl(config: any): boolean {
    return !!(
      config &&
      (config.ServiceURLHTTP ||
        config.ServiceURLHTTPS ||
        config.ServiceURL)
    );
  }

  private resolveServiceUrl(config: any, variable: string): string {
    const httpKey = `${variable}HTTP`;
    const httpsKey = `${variable}HTTPS`;

    if (this.isHTTPS === 'True') {
      return config[httpsKey] || config[httpKey] || config[variable] || '';
    }

    return config[httpKey] || config[variable] || '';
  }

  private initializeHttps(): void {
    if (typeof window === 'undefined') {
      return;
    }

    this.isHTTPS = window.location.protocol === 'https:' ? 'True' : 'False';
    localStorage.setItem('isHTTPS', this.isHTTPS);
  }

  private initializeCompanyCode(): void {
    if (!this.localUrl || localStorage.getItem('CompanyCode')) {
      return;
    }

    if (this.localUrl.GetCompanyCodeFromURL === 'Y') {
      const href = window.location.href.replace(/^https?:\/\//, '');
      const array = href.split('.');
      if (array.length > 2) {
        localStorage.setItem('CompanyCode', array[0]);
      }
      return;
    }

    if (this.localUrl.CompanyCode) {
      localStorage.setItem('CompanyCode', this.localUrl.CompanyCode);
    }
  }

  // It is provide the urls from the local json
  serviceUrl(variable: string) {
    if (!localStorage.getItem('isHTTPS')) {
      this.initializeHttps();
    } else {
      this.isHTTPS = localStorage.getItem('isHTTPS') || 'False';
    }

    const url = this.getConfig();
    if (!url) {
      return '';
    }

    return this.resolveServiceUrl(url, variable);
  }
}
